import {Injectable, OnInit, Type} from '@angular/core';
import {LanguageService} from './language.service';
import {LanguageCode, SUPPORTED_LANGUAGES_CONSTANTS} from '../../core/constants/languages.constants';
import {Router} from '@angular/router';
import {UserLocalDataModel} from '../../typings/models/user-local-data.model';
import {LocalStorageProviderService} from '../provider-services/local-storage.provider-service';
import {LOCAL_STORAGE_KEY_CONSTANTS} from '../../core/constants/local-key-storage.constants';
import {ToastProviderService} from '../provider-services/toast.provider-service';
import {ToastMessageTypeEnum} from '../../typings/enums/toast-message-type.enum';
import {ToastDurationTypeEnum} from '../../typings/enums/toast-duration-type.enum';
import {environment} from '../../../environments/environment';
import {DialogProviderService} from '../provider-services/dialog.provider-service';
import {ConfirmationDialogProviderService} from '../provider-services/confirmation-dialog.provider-service';
import {ConfirmationDialogModel} from '../../typings/models/confirmation-dialog.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(
    public router: Router,
    private localStorageProviderService: LocalStorageProviderService,
    private toastProviderService: ToastProviderService,
    private languageService: LanguageService,
    protected dialogProviderService: DialogProviderService,
    protected confirmationDialogProviderService: ConfirmationDialogProviderService,
  ) {
    this.initializeApp();
  }

  userInformation!: UserLocalDataModel | null;

  initializeApp(): void {
    if (!this.currentLanguageCode) {
      this.currentLanguageCode = this.getSupportedLanguages().find(x => x.code === environment.defaultLanguageCode)!.code;
    }

    this.languageService.currentLang$.subscribe(newLanguageCode => this.currentLanguageCode = newLanguageCode);
  }

  setUserInformationFromApi() {
    // TODO: it will changes and reads it from Api
    this.userInformation = this.localStorageProviderService.getObject(LOCAL_STORAGE_KEY_CONSTANTS.USER_INFORMATION);
  }

  setUserInformation(model: UserLocalDataModel): void {
    this.localStorageProviderService.setObject(LOCAL_STORAGE_KEY_CONSTANTS.USER_INFORMATION, model);
    this.userInformation = model;
  }

  removeUserInformation() {
    this.userInformation = null;
  }

  getSupportedLanguages() {
    return this.languageService.getSupportedLanguages();
  }

  currentLanguageCode!: LanguageCode;

  changeLanguage(languageCode: LanguageCode): void {
    this.languageService.changeLanguage(languageCode);
  }

  navigateTo(route: string, state?: any | null) {
    if (state && Object.keys(state).length > 0) {
      this.router.navigate([route], { state: state });
    } else {
      this.router.navigateByUrl(route);
    }
  }

  showToast(message: string, type?: ToastMessageTypeEnum, duration?: ToastDurationTypeEnum) {
    this.toastProviderService.show(message, type, duration);
  }

  openDialog<T>(
    component: Type<T>,
    inputs?: Partial<T>
  ) {
    return this.dialogProviderService.open(component, inputs);
  }

  closeDialog = () => this.dialogProviderService.close();
  showConfirmationDialog
    = (data: ConfirmationDialogModel, widthSize?: string) => this.confirmationDialogProviderService.showConfirmationDialog(data, widthSize);
}
